import { getSiteBrand } from "@/lib/siteHosts";

export const TERRITORY_STATUS_BADGE = {
  status: "OPEN ENROLLMENT · 2026",
  slot: "Roofing · Sydney · 1 partner slot",
};

export const TERRITORY_LOCK_THESIS = {
  headline: "One partner per city. Is it you or your competitor?",
  get subline() {
    return `Lock a niche in your city and every other agency is permanently blocked from selling the same ${getSiteBrand().name} stack there.`;
  },
};

export const TERRITORY_SLOT_EXAMPLE = {
  niche: "Roofing",
  city: "Sydney",
};

export const TERRITORY_SLOT_LOCKED = {
  owner: "YOUR AGENCY",
  status: "LOCKED",
  caption: "You own this niche",
};

export const TERRITORY_SLOT_BLOCKED = {
  owner: "COMPETITOR",
  status: "BLOCKED",
  caption: "Permanently excluded",
};

export const TERRITORY_STEPS = [
  { id: "apply", label: "Apply", detail: "Partner onboarding" },
  { id: "deploy", label: "Deploy", detail: "Activate niche slot" },
  { id: "locked", label: "Locked", detail: "Competitors blocked" },
];

export const TERRITORY_LOCK = {
  title: "Lock it",
  headline: "You own the niche",
  sub: "Sole AI provider in your city. No other agency can replicate your stack.",
};

export const TERRITORY_WAIT = {
  title: "Wait",
  headline: "Competitor locks it first",
  sub: "Your ad spend feeds their clients while you're locked out.",
};

export const TERRITORY_DETAILS = {
  summary: "How territory locking works",
  body:
    "When your agency activates a deployment slot (for example Roofing in Sydney or Medical in Brisbane), that vertical and region is blacklisted for other marketing networks. Once onboarding is complete, overlapping partner routes in the same niche are blocked.",
};

export const TERRITORY_CTA = {
  label: "Claim your territory",
  target: "partner-form",
};

export const TERRITORY_FOOTNOTE = "Territory availability subject to ops approval.";
